import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useStudentQuizCreate = () => {
  const createStudentQuizPostRequest = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v3/studentquiz/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createStudentQuizPostRequest);
};

export default useStudentQuizCreate;
